import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { Modal } from '@mui/material';

import COLOR from 'utils/constants/color';
import CotationLoader from 'components/CotationLoader';
import LoadingWrapper from 'components/LoadingWrapper';
import ParentCalenar from 'features/ParentCalendar';
import ParentVisual from 'features/ParentVisual';
import SentryWrap from 'components/Sentry';
import { filter, get, has, uniqBy } from 'lodash';
import queryString from 'query-string';
import styled from 'styled-components';
import { getCurrentUser } from 'aws-amplify/auth';
import { Col, Row } from 'antd';
import { getRandomCotation } from "utils/methods/math";
import { handleListActivities, handleListCustomAssignment } from 'store/activities/thunks';
import { handleListClassActivities, handleListClassActivitiesForStudent } from 'store/classActivities/thunks';
import { handleListClassBookmarks } from 'store/bookmark/thunks';
import { handleListClassQuizzes, handleListClassQuizzesForStudent } from 'store/classQuizzes/thunks';
import { handleListInstructionByClass } from "store/instructions/thunks";
import { handleListQuizzes } from 'store/quizzes/thunks';
import { handleListUserSubmissionsByClass } from 'store/submissions/thunks';
import { makeStyles } from 'utils/styles/mui';
import { useClassGameActivity } from 'store/one_game/selectors';
import ParentGradebook from './ParentGradebook';
import { useUI } from 'store/UI/selectors';
import DashboardHeader from 'modules/StudentDashboardNew/DashboardHeader';
import useActiveStudentofParent from 'components/hooks/parent/activeStudentofParent';
import { useClassBooks } from 'components/hooks/books/useClassBooks';

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------



;
//  -- Components ---------------------






//  -- Features -----------------------







//  -- Thunks -------------------------





//  -- Constants ----------------------










const ACTIVE_BTN_COLOR = `linear-gradient(to bottom right, ${COLOR.indigo100} , ${COLOR.indigo300})`
const DEACTIVE_BTN_COLOR = `linear-gradient(to right, ${COLOR.lightseagreen100} , ${COLOR.lightseagreen200})`
const getColor = (isActive) => isActive ? ACTIVE_BTN_COLOR : DEACTIVE_BTN_COLOR




//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------


const ButtonClear = styled.button`
    background-color: transparent;
    border: none;
    color: ${COLOR.black600};
    cursor: pointer;
    outline: none;
    padding: 0px;
`;

const ButtonLink = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${COLOR.black200};
    cursor: pointer;
    display: inline-flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 2px 0px;
    text-transform: uppercase;
`;

const CenterRow = styled.div`
    align-items: center;
    display: inline-flex;
    flex-direction; row;
    width: 100%;
`;

const Container = styled.div`
    padding: 24px 0px;
    padding-top:0px;
`;

const MobileMenu = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 600;

    @media (min-width: 992px) {
        display: none;
    }
`;

const Section = styled.div`
    margin-bottom: 64px;
    width: 100%;

    &:first-child {
        margin-bottom: 24px;
    }
`;

const SectionHeader = styled.span`
    border-bottom: 1px dashed ${COLOR.black800};
    color: ${COLOR.black300};
    display: block;
    font-size: 11px;
    font-weight 600;
    margin-bottom: 16px;
    padding-bottom: 4px;
    text-transform: uppercase;
     visibility: hidden;
`;

const Title = styled.span`
    color: ${COLOR.black100};
    display: inline-block;
    font-size: 16px;
    font-weight: 300;

    @media (min-width: 768px) {
        font-size: 24px;
    }
`;

const TitleContainer = styled.div`
    align-items: center;
    display: inline-flex;
    flex-direction; row;
`;



const WrapperHeader = styled.span`
    color: ${COLOR.black300};
    display: block;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 6px;
`;

const VideoContainer = styled.div`
    height: auto;
    flex: 1;
    justify-content: center;
`;

const Group = styled.div`
    display: none;

    @media (min-width: 992px) {
        align-items: center;
        display: flex;
        flex-direction: row;
    }
`;

const Mobicon = styled.img`
  height: 30px;
  width: 30px;
  align-self: center;
  object-fit: cover;
`;
const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    margin-right: 16px;
`;

const TabButton = styled.button`
    background-color: transparent;
    border: none;
    border-bottom: 2px solid ${p => p.active ? COLOR.green100 : 'transparent'};
    /* color: ${p => p.active ? COLOR.black100 : COLOR.black500}; */
    color: white;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 16px 24px;
    text-transform: uppercase;
    transition: all 300ms ease;
    margin-right: 5px;

    &:hover {
        border-bottom: 2px solid ${COLOR.green700};
        color: white;
    }
`;

const HeaderContainer = styled.div`
    align-items: center;
    border-bottom: 1px solid ${COLOR.black700};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 0px;
    padding: 24px 0px 6px;
    position: relative;

    @media (min-width: 992px) {
        margin-bottom: 0px;
        padding: 24px 0px 0px;
    }
`;

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        '& > *': {
            margin: '2px',
        },
    }
}));


const getTab = (key = "") => {
    switch (key) {
        case 'home':
            return key;
        case 'assessments':
            return key;
        case 'studentData':
            return key;
        default:
            return "home";
    }
}

const ParentDashboard = ({
    classActivities,
    classQuizzes,
    currentClass,
    currentUser,
    submissions,
    booksAllList,
    activities,
    quizzes,
    userPreference
}) => {
    const { fetchClassGameActivity } = useClassGameActivity()
    const classes = useStyles();
    const location = useLocation();
  							  const navigate = useNavigate();
    const search = queryString.parse(location.search);
    const dispatch = useDispatch();
    const [loading, setLoadingFlag] = useState(true);
    const [cotationLoader, setCotationLoader] = useState(true);
    const searchView = getTab(search.view);
    const cotationRef = useRef(null)
    const dataRef = useRef();
    const { quotesData = [] } = useUI();
    const { activeStudentParent } = useActiveStudentofParent();
    if (!cotationRef.current) {
        cotationRef.current = getRandomCotation(quotesData)
    }
    const { fetchClassBooks } = useClassBooks()
    const handleSearch = (val) => {
        dataRef.current?.applyAllFiltersAndSort(undefined, undefined, undefined, val);
    };

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    useEffect(() => {
        if (searchView == "home"||searchView == "studentData") {
            listCurrentClassInfo()
            dispatch(handleListClassActivities(currentClass?.id));
            dispatch(handleListClassQuizzes(currentClass?.id));
            fetchClassGameActivity();
            listAllAssignments()
        }
    }, [searchView])
    useEffect(() => {
        async function fetchData() {
            try {
                await getCurrentUser();
            } catch {
                navigate('/');
            }
        }
        fetchData();
    }, []);
    const listAllAssignments = async () => {
        return;
        if (!Array.isArray(activities) || activities.length == 0) {
           await  dispatch(handleListActivities());
        }
       
        if (!Array.isArray(quizzes) || quizzes.length == 0) {
          await   dispatch(handleListQuizzes());
        }
        await dispatch(handleListCustomAssignment('student',activeStudentParent))
    }

    const listCurrentClassInfo = async () => {
        if (has(currentClass, "id")) {
            dispatch(handleListClassActivitiesForStudent(get(currentClass, "id"),activeStudentParent));
            dispatch(handleListClassQuizzesForStudent(get(currentClass, "id"),activeStudentParent));
        }
    }
    const listInstructionByClass = async () => {
        if (has(currentClass, "id")) {
            dispatch(handleListInstructionByClass(get(currentClass, "id")));
        }
    }
    const getUserSubmissions = async () => {
       await dispatch(handleListUserSubmissionsByClass(activeStudentParent,currentClass?.id))
    }
    const listAllBooks = async () => {
        if (!booksAllList || booksAllList.length == 0) {
            await fetchClassBooks();
        }
    }

    const listClassBookmark = async () => {
        if (has(currentClass, "id")) {
            dispatch(handleListClassBookmarks(currentClass.id))
        }
    }
    const fetchAllData = async () => {
        setLoadingFlag(true);
        setCotationLoader(true)
        let currentClassId = localStorage.getItem("currentClassId")
        if ((currentClassId && (currentClassId ===currentClass?.id || currentClassId === "nocurrentuser"))) {
            setLoadingFlag(false)
            setCotationLoader(false)
        }
        await Promise.allSettled([
            listCurrentClassInfo(),
            listInstructionByClass(),
            getUserSubmissions(),
            listAllBooks(),
            listClassBookmark()
            
        ])
        localStorage.setItem("currentClassId", currentClass?.id ?? "nocurrentuser")
        setLoadingFlag(false);
        setCotationLoader(false)
    }

    useEffect(() => {
        fetchAllData();
        if(has(currentClass,"id")&&currentClass.archived){
            navigate(-1);
        }
    }, [currentClass,activeStudentParent]);
    const allGraded = filter(submissions, x => x.graded);;
    const getAssignment = () => {
        const uniqueActivity = uniqBy(classActivities, "activityId");
        const uniqueQuiz = uniqBy(classQuizzes, 'quizId')
        return [...uniqueActivity, ...uniqueQuiz]
    }

    const toolbarNav = () => ({
        items: [
            {
                key: 'home',
                label: (
                    <ButtonClear onClick={() => handleTabs('home')}>
                        Home
                    </ButtonClear>
                )
            },
            {
                key: 'studentData',
                label: (
                    <ButtonClear onClick={() => handleTabs('studentData')}>
                        Student data
                    </ButtonClear>
                )
            }
        ]
    });
    const handleTabs = (key) => {
        switch (key) {
            case 'home':
                navigate('/parent/class?view=home');
                fetchAllData();
                break;
            // case 'assessments':
            //     navigate('/parent/class?view=assessments');
            //     fetchAllData();
            //     break;
            case 'studentData':
                navigate('/parent/class?view=studentData');
                break;
            default:
                break;
        }
    }
    return (
        <>
            <Modal
                className={classes.modal}
                open={cotationLoader}
            >
                <VideoContainer>
                    <CotationLoader cotation={cotationRef.current} />
                </VideoContainer>
            </Modal>
            <DashboardHeader 
                handleTabs={handleTabs}
                onSearchChange={handleSearch}
            />
            <Row>
                {/* <Col span={24}>
                    <HeaderContainer>
                        <TitleContainer>
                            <CenterRow>
                                <Mobicon src={mobileMenuimg} />
                                <Title>{currentClass.displayName}</Title>
                            </CenterRow>
                        </TitleContainer>
                        <Group>
                            <ButtonGroup>
                                <TabButton
                                    style={{ backgroundImage: getColor(searchView === 'home') }}
                                    active={searchView === 'home'} onClick={() => handleTabs("home")}>
                                    Home
                                </TabButton>
                                <TabButton
                                    style={{ backgroundImage: getColor(searchView === 'studentData') }}
                                    active={searchView === 'studentData'} onClick={() => handleTabs('studentData')}>
                                    Student data p
                                </TabButton>
                            </ButtonGroup>
                        </Group>
                        <MobileMenu>
                            <Dropdown menu={toolbarNav()} placement="bottomRight" trigger={['click']}>
                                <ButtonLink onClick={e => e.preventDefault()}>
                                    <MenuOutlined style={{ fontSize: '18px' }} />
                                </ButtonLink>
                            </Dropdown>
                        </MobileMenu>
                    </HeaderContainer>
                </Col> */}
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                    <Container>
                        <Row className="tabCollection wrapperAdmnDash" style={{ marginTop:12}}>
                            <Col className="contentAdmnDash" xs={{ span: 24 }} sm={24} lg={{ span: 24 }}>
                            
                        {/* {searchView == 'home' && (
                            <>
                                <Section
                                    description="Below are the chapters for the book. Clicking on a chapter will display the book."
                                    header='Home'
                                >
                                    <LoadingWrapper loading={loading} hasCotationLoaded={true}>
                                      
                                    </LoadingWrapper>
                                </Section>
                            </>
                        )} */}
                        {searchView == 'home' && (
                            <>
                                <Section>
                                    <SectionHeader>My Calendar</SectionHeader>
                                    <LoadingWrapper loading={loading}>
                                        <SentryWrap>
                                            <ParentCalenar
                                                assignments={getAssignment()}
                                                submissions={submissions}
                                                booksAllList={booksAllList}
                                                currentUser={currentUser}
                                                userBooks={[]}
                                                userPreference={userPreference}
                                             />
                                             <ParentGradebook/>
                                        </SentryWrap>
                                    </LoadingWrapper>
                                </Section>
                            </>
                        )}
                        {searchView == 'studentData' && (
                            <>
                                <Section>
                                    <SectionHeader>My Data</SectionHeader>
                                    <LoadingWrapper loading={loading}>
                                        <SentryWrap>
                                            <ParentVisual
                                                ref={dataRef}
                                                allGraded={allGraded}
                                                classActivities={classActivities}
                                                classQuizzes={classQuizzes}
                                                assignments={getAssignment()}
                                            />
                                        </SentryWrap>
                                    </LoadingWrapper>
                                </Section>
                            </>
                        )}
                        </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </>
    );
};

const mapStateToProps = state => ({
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    currentClass: state.currentClass,
    currentUser: state.currentUser,
    currentOrg: state.currentOrg,
    submissions: state.submissions,
    booksAllList: state.booksAllList,
    userClasses: state.userClasses,
    activities: state.activities,
    quizzes: state.quizzes,
    userPreference: state.userPreference
});

export default connect(mapStateToProps, null)(ParentDashboard);